import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { CalcsService } from '../calcs.service';
import { SubscribeDialogComponent } from '../subscribe-dialog/subscribe-dialog.component';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-home-five',
  templateUrl: './home-five.component.html',
  styleUrls: ['./home-five.component.css']
})
export class HomeFiveComponent implements OnInit {

  form = this.fb.group({
    "email": [null, [Validators.required, Validators.email]],
    "date": [null],
    "reminder": [true],
  })
  
  faSpinner = faSpinner
  loading = false;
  isMobile = false
  width = window.innerWidth

  constructor(
    public dialog: MatDialog,
    public fb: FormBuilder, 
    public calcService: CalcsService) { }

  ngOnInit(): void {
    this.mobileTest()
    var today = new Date().toISOString().split('T')[0];
    document.getElementsByName("date")[0].setAttribute('min', today);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.width = window.innerWidth
    this.mobileTest()
  }

  mobileTest() {
    return this.isMobile = this.width < 992 ? true : false
  }

  submit() {
    if (this.form.invalid) {
      this.calcService.showSnack('Invalid Email Address')
      return
    }

    if (this.form.value.reminder && this.form.value.date == null) {
      this.calcService.showSnack('Please enter a valid date')
      return
    }

    if (this.form.value.date != null) {
      this.form.controls.reminder.setValue(true);
    }

    this.loading = true

    setTimeout(() => {
      this.openDialog()
      this.loading = false
      this.form.reset()
    },1000)
  }

  openDialog() {

    const dialogRef = this.dialog.open(SubscribeDialogComponent, {
        width: '500px',
        disableClose: true,
        data: {
          reminder: this.form.value.reminder,
          date: this.form.value.date
        }
    });

    dialogRef.afterClosed().subscribe(result => {
      
    });
  }
}
